module.exports = __webpack_public_path__ + "static/media/Chlodzenie.dc9a9b47.svg";